// Vendor Libs
import React from 'react';

// Components
import AuditDetail from '../search-data/audit-detail';
import Audits from '../search-data/audits';
import FlexDashboard from '../core/flex-dashboard';
import MediaItemAudits from '../search-data/mediaitem-audits';
import MediaItemDetailAudit from '../search-data/mediaitem-detail-audit';
import Permissions from '../core/permissions';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Audits',
                        component: Audits,
                    },
                ],
            },
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Audit Detail',
                                component: AuditDetail,
                            },
                        ],
                        weight: 150,
                    },
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Associated Media Item',
                                component: MediaItemDetailAudit,
                            },
                            {
                                type: 'tab',
                                name: 'Media Item Audits',
                                component: MediaItemAudits,
                            },
                        ],
                    },
                ],
            },
        ],
    },
};

function DashboardAudits() {
    return (
        <Permissions adminOnly={true} autoRedirect={true}>
            <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="audits" version="1" />
        </Permissions>
    );
}

export default DashboardAudits;
